import { Button } from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';
import { Col } from "antd";
import { get } from "lodash";
import React, { useMemo } from "react";
import styled from "styled-components";
import { Pic1 } from "utils/assets/images";

function RenderStory({
  book,
  onClick,
  onDelete,
  isSelection,
  selectedItem,
  selectedLevel,
  setSelectedLevel,
  handleOnClose
}) {
  const image = get(book, "img", Pic1);

  const selectedDataIds = useMemo(() => {
    return selectedItem?.map((item) => item.id) || "";
  }, [selectedItem]);

  const isItemSelected = selectedDataIds?.includes(book?.id);
  const currentSelectedLevel = selectedLevel?.[book.id] || null;

  const onClickEdit = () => {
    onClick(book);
  };

  const handleLevelSelect = (level) => {
    setSelectedLevel((prev) => ({
      ...prev,
      [book.id]: level,
    }));
  };

  return (
    <Col xs={24} sm={24} md={12} lg={8}>
      <div className="ImgBtn">
        <label>{get(book, "title", "")}</label>
        <div className="coverBtns">
          {isSelection ? null : (
            <div className="btnsGrpMain">
              <div className="btnsGrpTxt" style={{ justifyContent: "center" }}>
                <Button className="btnsTxtYellow" onClick={onClickEdit}>
                  <Edit style={{ fontSize: 20, marginRight: 3 }} />
                  Edit
                </Button>
                <Button
                  style={{ marginLeft: 10 }}
                  variant="contained"
                  color="secondary"
                  onClick={() => onDelete(book)}
                >
                  <Delete style={{ fontSize: 20, marginRight: 3 }} />
                  Delete
                </Button>
              </div>
            </div>
          )}

          <Wrapper onClick={onClickEdit} selected={isItemSelected}>
            <img src={image} />

            {/* Only show level selection buttons if item is selected */}
            {isItemSelected && (
              <LevelButtonsContainer>
                <InfoText>Please select one level</InfoText>
                <div className="btnsGrpTxt storyBtnsGrpTxt">
                  <div className="storyFistTwoBtn">
                    <LevelButton
                      className="btnsTxtGreen"
                      $isSelected={currentSelectedLevel === "Prebásico"}
                      onClick={async (e) => {
                        e.stopPropagation();
                        await handleLevelSelect("Prebásico");
                        handleOnClose()
                      }}
                      disabled={true}
                    >
                      Prebásico
                    </LevelButton>
                    <LevelButton
                      className="btnsTxtYellow"
                      $isSelected={currentSelectedLevel === "BASICO"}
                      onClick={async (e) => {
                        e.stopPropagation();
                        await handleLevelSelect("BASICO");
                        handleOnClose()
                      }}
                    >
                      Básico
                    </LevelButton>
                  </div>
                  <div className="storyFistTwoBtn">
                    <LevelButton
                      className="btnsTxtPurpal"
                      $isSelected={currentSelectedLevel === "INTERMEDIO"}
                      onClick={async (e) => {
                        e.stopPropagation();
                        await handleLevelSelect("INTERMEDIO");
                        handleOnClose()
                      }}
                    >
                      Intermedio
                    </LevelButton>
                    <LevelButton
                      className="btnsTxtAsmani"
                      $isSelected={currentSelectedLevel === "Avanzado"}
                      onClick={async (e) => {
                        e.stopPropagation();
                        await handleLevelSelect("Avanzado");
                        handleOnClose();
                      }}
                    >
                      Avanzado
                    </LevelButton>
                  </div>
                </div>
              </LevelButtonsContainer>
            )}
          </Wrapper>
        </div>
      </div>
    </Col>
  );
}

export default RenderStory;

const SelectedLevelIndicator = styled.div`
  background-color: #4caf50;
  color: white;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 5;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
`;

const Wrapper = styled.button`
  background-color: transparent;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  height: auto;
  outline: none;
  padding: 2px;
  transition: all 250ms cubic-bezier(0.4, 0, 0.2, 1);
  width: 100%;
  position: relative;
  overflow: hidden;

  /* Box shadow based on selection state */
  box-shadow: ${({ selected }) =>
    selected
      ? "0 0 12px 4px rgba(24, 144, 255, 0.8)" // brighter highlight for selected
      : "0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24)"};

  /* Background subtle effect on selection */
  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${({ selected }) =>
      selected ? "rgba(24, 144, 255, 0.05)" : "transparent"};
    z-index: 0;
    transition: background-color 300ms ease;
  }

  /* Border effect on selection */
  border: ${({ selected }) =>
    selected ? "2px solid rgba(24, 144, 255, 0.7)" : "2px solid transparent"};

  /* Scale effect when clicked */
  &:active {
    transform: scale(0.98);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
  }

  /* Hover effects */
  &:hover {
    box-shadow: 0 6px 14px rgba(0, 0, 0, 0.18), 0 4px 8px rgba(0, 0, 0, 0.16);

    &:before {
      background-color: rgba(0, 0, 0, 0.03);
    }
  }

  /* Ripple effect on click */
  &:after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 5px;
    height: 5px;
    background: rgba(255, 255, 255, 0.5);
    opacity: 0;
    border-radius: 100%;
    transform: scale(1, 1) translate(-50%, -50%);
    transform-origin: 50% 50%;
  }

  &:focus:not(:active)::after {
    animation: ripple 0.6s ease-out;
  }

  @keyframes ripple {
    0% {
      transform: scale(0, 0) translate(-50%, -50%);
      opacity: 0.5;
    }
    100% {
      transform: scale(20, 20) translate(-50%, -50%);
      opacity: 0;
    }
  }

  /* Ensure content is above pseudo-elements */
  & > * {
    position: relative;
    z-index: 1;
  }
`;

const LevelButtonsContainer = styled.div`
  position: absolute;
  bottom: 65px;
  left: 0;
  right: 0;
`;

const LevelButton = styled(Button)`
  position: relative;
  transition: all 0.3s ease;

  ${(props) =>
    props.$isSelected &&
    !props.disabled &&
    `
    background-color: #1a1a1a !important;
    color: white !important;
    border-color: #1a1a1a !important;
    box-shadow: 0 4px 12px rgba(26, 26, 26, 0.6) !important;
    transform: translateY(-2px);
    z-index: 10;
    
    &::before {
      content: '';
      position: absolute;
      top: -2px;
      left: -2px;
      right: -2px;
      bottom: -2px;
      background: #000000;
      border-radius: inherit;
      z-index: -1;
    }
    
    &:hover {
      background-color: #000000 !important;
      color: white !important;
    }
  `}

  &.Mui-disabled,
  &:disabled {
    background-color: #e8eaed !important;
    color: #9aa0a6 !important;
    border-color: #dadce0 !important;
    box-shadow: none !important;
    transform: none !important;
    opacity: 1 !important;
    cursor: not-allowed !important;
    -webkit-text-fill-color: #9aa0a6 !important;
    cursor: not-allowed !important;
    pointer-events: none !important;
    opacity: 0.7 !important;
    transform: none !important;
    box-shadow: none !important;
    border-color: #dadce0 !important;
    background-color: #e8eaed !important;
    color: #9aa0a6 !important;
  }

  &.Mui-disabled::before,
  &:disabled::before {
    display: none;
  }

  &:hover:not([disabled]):not(.Mui-disabled) {
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  }
`;
const ButtonContanier = styled.div`
  margin-right: 25px;
  position: absolute;
  right: 33px;
  top: 10px;
`;

const InfoText = styled.div`
  color: #666;
  font-size: 12px;
  text-align: center;
  margin-bottom: 8px;
  font-weight: 500;
  background: rgba(255, 255, 255, 0.9);
  padding: 4px 8px;
  border-radius: 4px;
  backdrop-filter: blur(2px);
  position: relative;
  bottom: 80px;
`;
